export enum FileTypes {
  ALL_IMAGES = 'image/*',
  PNG_IMAGES = 'image/png',
  JPEG_IMAGES = 'image/jpeg',
  PDF = 'application/pdf',
  EXCEL = 'application/vnd.ms-excel',
  EXCEL_XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  CSV = 'text/csv',
  SVG = 'image/svg+xml',
  TEXT = 'text/plain',
  WORD = 'application/msword',
  WORD_DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
}
